import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './RecommendPage.css';

import addIcon from './../../image/add.svg';
import editIcon from './../../image/edit.png';

const RecommendPage = ({ setCurrentPage, setSelectedRecommendation }) => {
    // список рекомендаций
    const [recommendList, setRecommendList] = useState([]);
    const [currentPagginationPage, setCurrentPagginationPage] = useState(1);

    useEffect(() => {
        console.log(recommendList);
    }, [recommendList]);

    // получение рекомендаций
    useEffect(() => {
        const handleRecommendLoading = async () => {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/manage/ads',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            page: currentPagginationPage,
                        },
                    }
                );
                if (response.data.success) {
                    setRecommendList(response.data.result);
                }
            } catch (error) {
                console.error('Ошибка получения рекомендаций ', error);
            }
        };

        handleRecommendLoading();
    }, [currentPagginationPage]);

    // страница категорий
    const handleMenuClick = () => {
        setCurrentPage('Menu');
    };

    // страница рекомендаций
    const handleRecommendationsClick = () => {
        setCurrentPage('Recommendations');
    };

    // добавить рекомендацию
    const handleRecommendationsAddClick = () => {
        setCurrentPage('RecommendationsAdd');
    };

    // форматирование даты
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const timezoneOffset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - timezoneOffset * 60 * 1000);

        const formattedDate = localDate.toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });

        return formattedDate;
    };

    // клик по рекомендации
    const handleRecommendationClick = (recommend) => {
        setSelectedRecommendation(recommend);
        setCurrentPage('RecommendationsEdit');
    };

    // переключение страниц
    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= Math.ceil(recommendList.allCount / 15)) {
            setCurrentPagginationPage(newPage);
        }
    };

    return (
        <div className='menu__wrapper'>
            <div className='menu__items_one'>
                <p className='menu__item_name' onClick={handleMenuClick}>
                    Категории
                </p>
                <p
                    className='menu__item_name'
                    onClick={handleRecommendationsClick}
                >
                    Рекомендации
                </p>
            </div>
            <div className='menu__items_two'>
                <div className='menu__nav'>
                    <input
                        type='text'
                        placeholder='Поиск рекомендаций'
                        className='menu__input'
                    />
                    <div
                        className='menu__add_btn'
                        onClick={handleRecommendationsAddClick}
                    >
                        <img src={addIcon} alt='add' />
                    </div>
                </div>
                <div className='recommends__list'>
                    {recommendList.allCount > 0 && (
                        <table className='recommend__table'>
                            <thead className='recommend__table_thead'>
                                <tr>
                                    <th>id</th>
                                    <th>Название</th>
                                    <th>Дата начала</th>
                                    <th>Дата окончания</th>
                                    <th>Подкатегория</th>
                                    <th>Локация</th>
                                    <th>Статус</th>
                                    <th>Статус оплаты</th>
                                </tr>
                            </thead>
                            <tbody className='recommend__table_tbody'>
                                {recommendList.items.map((recommend) => (
                                    <tr
                                        key={recommend.id}
                                        onClick={() =>
                                            handleRecommendationClick(recommend)
                                        }
                                    >
                                        <td>{recommend.id}</td>
                                        <td>{recommend.name}</td>
                                        <td>{formatDate(recommend.start)}</td>
                                        <td>{formatDate(recommend.end)}</td>
                                        <td>
                                            {recommend.eventSubCategoryName}
                                        </td>
                                        <td>{recommend.city}</td>
                                        <td>{recommend.status}</td>
                                        <td>{recommend.paymentStatus}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                    {recommendList.allCount > 0 && (
                        <div className='recommend__paggination'>
                            <button
                                onClick={() =>
                                    handlePageChange(currentPagginationPage - 1)
                                }
                            >
                                Предыдущая
                            </button>
                            <p>
                                {currentPagginationPage} из{' '}
                                {Math.ceil(recommendList.allCount / 15)}
                            </p>
                            <button
                                onClick={() =>
                                    handlePageChange(currentPagginationPage + 1)
                                }
                            >
                                Следующая
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RecommendPage;
